import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { APP_OPTIONS } from '../../config/constants';

const MenuSearchBar = ({ setSearchBarVisible }) => {
  const history = useHistory();

  const onSubmit = (e) => {
    e.preventDefault();
    const query = e.target[0].value;
    history.push(`zoeken?${APP_OPTIONS.parameters.searchkitIndexAllContent}%5Bquery%5D=${query}`);
    setSearchBarVisible(false);
  };

  useEffect(() => {
    document.getElementById('searchbar_query_input').focus();
  }, []);

  return (
    <div className="App__searchbar">
      <div className="overlay" onClick={() => setSearchBarVisible(false)} />
      <div className="Navigation__search_expand">
        <div className="SearchBar Searchkit__SearchBar">
          <form onSubmit={onSubmit}>
            <div className="SearchBar__inner">
              <div className="TextField">
                <input id="searchbar_query_input" name="query" placeholder="Zoek op bijv. cao-wijzigingen, wetgeving, arbeidsmarkt etc" />
              </div>
              <button type="submit" className="Button SearchBar__submit Button--primary">Zoek</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default MenuSearchBar;
